module.exports = __webpack_public_path__ + "static/media/delirio-bajo-el-tacto.0c61514c.jpg";